import { COM_RELOAD_USERINFO, COM_SET_BREADCRUMB } from '../types';

const state = {
    reloadUser: false,
    breadcrumb: '',
};

const actions = {
    setreloadUserState({ commit }, status) {
        commit(COM_RELOAD_USERINFO, status);
    },
    setBreadcrumb({ commit }, status) {
        commit(COM_SET_BREADCRUMB, status);
    },
};

const getters = {
    reloadUser: state => state.reloadUser,
    breadcrumb: state => state.breadcrumb,
};

const mutations = {
    [COM_RELOAD_USERINFO](state, status) {
        state.reloadUser = status;
    },
    [COM_SET_BREADCRUMB](state, str) {
        state.breadcrumb = str;
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};
